import { Component } from '@angular/core';

import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  selector   : 'wor-checkbox-control',
  styles: [ require('./checkbox-control.component.scss') ],
  template: require('./checkbox-control.component.html')
})
export class CheckboxControlComponent extends TextControlComponent {}
